module.exports = __webpack_public_path__ + "img/ac5942b.png";